import {
  CreateFirebaseToken,
  CreateUser,
  EntityId,
  Result,
  Service,
  UpdateUser,
  User,
  UserServicesRequest,
} from "@models";
import requests from "./agent";

export const userService = {
  getAllByTenantId: async (tenantId: string | undefined) => {
    const response = await requests.get<Result<User[]>>(
      "/api/User/GetAll?tenantId=" + tenantId
    );
    return response.result;
  },

  getServices: async (request: UserServicesRequest) => {
    const response = await requests.get<Result<Service[]>>(
      `/api/User/GetServices`,
      {
        params: request,
      }
    );
    return response.result;
  },

  get: async (id: EntityId) => {
    const response = await requests.get<Result<User>>(
      "/api/services/app/User/Get",
      { params: id }
    );
    return response.result;
  },

  getProfile: async () => {
    const response = await requests.get<Result<User>>(
      "/api/services/app/User/GetProfile"
    );
    return response.result;
  },

  create: async (request: CreateUser) => {
    const response = await requests.post<Result<User>>(
      "/api/services/app/User/Create",
      request
    );
    return response.result;
  },

  updateProfile: async (request: UpdateUser) => {
    const response = await requests.put<Result<User>>(
      "/api/services/app/User/UpdateProfile",
      request
    );
    return response.result;
  },

  createFirebaseToken: async (request: CreateFirebaseToken) => {
    const response = await requests.post<Result<void>>(
      "/api/services/app/User/CreateFirebaseToken",
      request
    );
    return response.result;
  },

  deleteFirebaseToken: async (token: string) => {
    await requests.delete<Result<void>>(
      "/api/services/app/User/DeleteFirebaseToken",
      { params: { token } }
    );
  },
};
